module.exports = __webpack_public_path__ + "img/icon_youshi03.e43752b3.png";